import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const whatsappApi = createApi({
  reducerPath: 'whatsappApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({

    sendWhatsappBill: builder.mutation({
      // A POS order (orderId), a gift voucher sale (giftVoucherSaleId) or a return's
      // credit note (orderReturnId) — same endpoint.
      // source: 'checkout' | 'order_history' — each place has its own send limit.
      query: ({ orderId, giftVoucherSaleId, orderReturnId, source = 'checkout', billBlob, filename }) => {
        const formData = new FormData();
        if (orderReturnId) formData.append('order_return_id', orderReturnId);
        else if (giftVoucherSaleId) formData.append('gift_voucher_sale_id', giftVoucherSaleId);
        else formData.append('order_id', orderId);
        formData.append('source', source);
        formData.append('bill', billBlob, filename);
        return { url: '/whatsapp/send_bill', method: 'POST', body: formData };
      },
    }),

    updateWhatsappOptIn: builder.mutation({
      query: ({ customerId, optedIn }) => ({
        url: `/customers/${customerId}/whatsapp_opt_in`,
        method: 'PATCH',
        body: { opted_in: optedIn },
      }),
    }),

  }),
});

export const { useSendWhatsappBillMutation, useUpdateWhatsappOptInMutation } = whatsappApi;
